import { render, staticRenderFns } from "./TextPayment.vue?vue&type=template&id=bc2bad40&"
import script from "./TextPayment.vue?vue&type=script&lang=js&"
export * from "./TextPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports